import z from "zod";

export const ADMIN_ROLES = ["owner", "admin"] as const;
export const adminRoleSchema = z.enum(ADMIN_ROLES);
export type AdminRole = z.infer<typeof adminRoleSchema>;

export const DEPARTMENT_ROLES = ["manager", "member"] as const;
export const departmentRoleSchema = z.enum(DEPARTMENT_ROLES);
export type DepartmentRole = z.infer<typeof departmentRoleSchema>;

export const ROLES = [...ADMIN_ROLES, ...DEPARTMENT_ROLES] as const;
export const roleSchema = z.enum(ROLES);
export type Role = z.infer<typeof roleSchema>;
